import React from 'react'
import Classes from '../../ViewClientPage.module.css'

export default function Sidebar({ activeTab, setActiveTab }) {
    return (
        <ul className={Classes.sidebar} >
            <li className={activeTab === "details" ? Classes.active : ""}
                onClick={() => setActiveTab("details")}>
                <h5>Details</h5>
            </li>

            <li className={activeTab === "notes" ? Classes.active : ""}
                onClick={() => setActiveTab("notes")}>
                <h5>Notes</h5>
            </li>

            <li className={activeTab === "orders" ? Classes.active : ""}
                onClick={() => setActiveTab("orders")}>
                <h5>Orders</h5>
            </li>

            <li className={activeTab === "subscriptions" ? Classes.active : ""}
                onClick={() => setActiveTab("subscriptions")}>
                <h5>Subscriptions</h5>
            </li>

            <li className={activeTab === "invoices" ? Classes.active : ""}
                onClick={() => setActiveTab("invoices")}>
                <h5>Invoices</h5>
            </li>

            <li className={activeTab === "forms" ? Classes.active : ""}
                onClick={() => setActiveTab("forms")}>
                <h5>Forms</h5>
            </li>

            <li className={activeTab === "documents" ? Classes.active : ""}
                onClick={() => setActiveTab("documents")}>
                <h5>Documents</h5>
            </li>
        </ul>
    )
}
